import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import LocizeBackend from 'i18next-locize-backend'
import { initReactI18next } from 'react-i18next'
import { supportedLangs } from './utils/language'

const languageDetector = new LanguageDetector()

i18n
  .use(languageDetector)
  .use(LocizeBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    preload: ['en'],
    supportedLngs: supportedLangs,
    returnObjects: true,
    lowerCaseLng: false,
    debug: true,
    fallbackLng: 'en',
    ns: ['vpc', 'common'],
    defaultNS: 'vpc',
    saveMissing: true,
    interpolation: {
      prefix: '__',
      suffix: '__',
      format: (value, format, lng) => {
        if (format === 'intlDate') {
          // e.g., for "en"/"en-US": "Apr 28, 2025, 8:58 PM"
          if (!value || value.toString() === 'Invalid Date') {
            return value
          }
          return new Intl.DateTimeFormat(lng, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          }).format(value)
        } else if (format === 'intlInteger') {
          return new Intl.NumberFormat(lng).format(value)
        }
        return value
      },
    },
    backend: {
      projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
      referenceLng: 'en',
      version: import.meta.env.VITE_LOCIZE_VERSION,
      apiKey: import.meta.env.VITE_LOCIZE_API_KEY || undefined,
      private: import.meta.env.VITE_LOCIZE_USE_PRIVATE_API || undefined,
    },
  })
